import { IsOptional } from 'class-validator';

export class DateRangeDto {
	@IsOptional()
	startDate?: Date | null;

	@IsOptional()
	endDate?: Date | null;
}
